/* eslint-disable */
import AOS from 'aos';

export default {
  init() {
    // JavaScript to be fired on all pages
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
    AOS.init({
      once: true,
      // offset: -85
      offset: 20,
    });

    $(document).ready(function () {
      init_video_banner();
    });

    $(window).resize(function () {
      init_video_banner()
    });

    function init_video_banner() {
      if (window.innerWidth >= 992) {
        loadPlayer();
        $('#player').show();

      } else {
        $('#player').hide();
      }
    }

    if ($('.banner-carousel').length) {
      $('.banner-carousel').owlCarousel({
        loop: true,
        items: 1,
        nav: false,
        dots: false,
        autoplay: true,
        autoplaySpeed: 700
      });
    }

    function getVidId() {
      return $('[data-video]').data('video');
    }

    function loadPlayer() {
      if (typeof (YT) == 'undefined' || typeof (YT.Player) == 'undefined') {

        var tag = document.createElement('script');
        tag.src = "https://www.youtube.com/iframe_api";
        var firstScriptTag = document.getElementsByTagName('script')[0];
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

        window.onYouTubePlayerAPIReady = function () {
          onYouTubePlayer();
        };
      }
    }

    var player;

    function onYouTubePlayer() {
      player = new YT.Player('player', {
        videoId: getVidId(),
        playerVars: { controls: 10, autoplay: 1, showinfo: 0, rel: 0, showsearch: 0, iv_load_policy: 3, mute: 1, loop: 1 },
        events: {
          'onStateChange': onPlayerStateChange,
        }
      });
    }

    var done = false;
    function onPlayerStateChange(event) {
      event.target.mute();
      if (event.data == YT.PlayerState.PLAYING && !done) {
        done = true;
      }
      else if (event.data == YT.PlayerState.ENDED) {
        // player.stopVideo();
        player.playVideo();
      }
    }

    function stopVideo() {
      player.stopVideo();
    }

    $('.search-btn-outer').click(function () {
      $('.search-wrap').addClass('d-block');
      $('.search-wrap #ajax-search').focus();

      setTimeout(function () {
        $('body').addClass('search-open');
        $('.search-wrap').addClass('show');
      }, 10);

    });
    $('.btn-close').click(function () {
      $('.search-wrap').removeClass('show');

      setTimeout(function () {
        $('body').removeClass('search-open');
        $('.search-wrap').removeClass('d-block');
      }, 100);

    });

    $(document).on('submit', '#search-form', function (event) {
      event.preventDefault();
    });

    // gform restriction bypass
    if ($('input[type="submit"]').length > 0) {
      $('input[type="submit"]').each(function () {
        $(this).attr('aria-label', 'Submit');
      });
    }

    $('#ajax-search').on('input', function (e) {
      if (e.keyCode == 13) {
        e.preventDefault();
      }
      let search = $(this).val();

      if (search.length >= 3) {

        /**
         * Grab the JSON.
         */
        $.ajax({
          url: `/wp-json/wp/v2/pages?_embed&search=${search}&per_page=6`,
        })
          .done(function (res) {
            let $row = $('.ajax-search-row');
            $row.empty();

            if (res.length == 0) {

              $('.ajax-search-row').empty();
              $('.ajax-search-row').append('<div class="col-12">Sorry, no results were found. Please try another search term.</div>')
              // $('.default-posts').hide();
              $('.ajax-search-row').show();
              return;
            }


            // Append the new items to the row.
            res.forEach(function (res) {

              var image_url = '/wp-content/uploads/2020/05/bright-blue-default.jpg';

              if (res.acf.hasOwnProperty('banner_image')) {
                if (res.acf.banner_image !== false) {
                  image_url = res.acf.banner_image.url;
                }

                if (res.acf.banner_type == "video") {
                  image_url = res.acf.mobile_banner_image.url
                }

              }

              let element = `
              <div class="col-md-6 col-lg-4">
                <div class="quick-links-item">
                  <a href="${res.link}">
                    <div class="image-wrap">
                      <div class="image-holder" style="background-image: url(${image_url})"></div>
                    </div>
                    <h3 class="quick-links-title">${res.title.rendered}</h3>
                  </a>
                </div>
              </div>
             `;

              $row.append(element);

              $('.default-posts').hide();
              $('.ajax-search-row').show();

            });
          })
          .fail(function (res) {

            $('.ajax-search-row').empty();
            $('.ajax-search-row').append('<p>Sorry, something went wrong. Are you connected to the internet?</p>')
            $('.default-posts').hide();
            $('.ajax-search-row').show();

          })

      } else {

        $('.default-posts').show();
        $('.ajax-search-row').hide();
      }
    });

    // Footer certificates slider
    $('.certificate-carousel').owlCarousel({
      loop: true,
      margin: 10,
      autoplay: true,
      autoplaySpeed: 500,
      responsiveClass: true,
      dots: false,
      responsive: {
        0: {
          items: 2,
          nav: false
        },
        600: {
          items: 3,
          nav: false
        },
        1000: {
          items: 4,
          nav: false,
          loop: true
        }
      }
    });




    /**
     * Add dropdown Lang switcher.
     */
    $('#main-navigation').prepend(`
      <div class="lang-switcher-mobile">
          <div class="title d-flex justify-content-between notranslate"><span class="notranslate">Language</span><button id="toggle-lang-switcher" class="menu-caret icon-down-arrow"></button></div>
       </div>
    `);

    /**
     * Add languages to the list.
     */
    var options_list = "";
    $('#gtranslate_selector option').each(function () {
      if ($(this).val()) {
        options_list += `<button class="language-item notranslate" data-val="${$(this).val()}"> ${$(this).text()} </button>`;
      }
    });

    options_list = `<div class="d-none item-wrap"> ${options_list} </div>`; // Wrap options

    $('.lang-switcher-mobile').append(options_list);

    /**
     * Toggle lang switcher.
     */
    $('#toggle-lang-switcher').click(function () {
      $(this).toggleClass('active')
      $('.item-wrap').toggleClass('d-none');
      $('.item-wrap').toggleClass('d-flex');
    });

    $('.socials').clone().appendTo("#main-navigation");

    /**
     * Drop down parent link
     */

    $('.dropdown-toggle').click(function () {
      window.location = $(this).attr('href');
    });


    /**
     * Change lang on click.
     */
    $('header').click(function (e) {
      if ($(e.target).hasClass('language-item')) {
        let val = $(e.target).data('val');
        doGTranslate(val);

        $('#toggle-lang-switcher').toggleClass('active')
        $('.item-wrap').toggleClass('d-none');
        $('.item-wrap').toggleClass('d-flex');

        return;
      }

      if ($(e.target).closest('button').hasClass('language-item')) {
        doGTranslate($(e.target).closest('button').data('val'));


        $('#toggle-lang-switcher').toggleClass('active')
        $('.item-wrap').toggleClass('d-none');
        $('.item-wrap').toggleClass('d-flex');
      }
    });

    /**
     * Add dropdown toggle.
     */
    $('.navbar .menu-item-has-children').each(function () {
      $(this).append(`
        <button class="toggle-sub-menu d-block d-lg-none menu-caret icon-down-arrow"></button>
      `);
    });

    /**
     * Open & close sub-menu.
     */
    $('.toggle-sub-menu').click(function () {
      // open close
      $(this).toggleClass('active')
      $(this).siblings('ul').toggleClass('show');
    });

    $('.dropdown-toggle').click(function () {
      // open close
      $(this).siblings('.toggle-sub-menu').toggleClass('active');
      $(this).siblings('ul').toggleClass('show');
    });

    /**
     * Watch the menu for open & close.
     */

    $('.navbar-toggler').click(function () {

      $('.navbar').toggleClass('navbar-open');
      $('body').toggleClass('overflow-hidden');

      // Toggle icons.
      if ($('.main-logo').hasClass('logo-light')) {
        let $logo = $('.main-logo');
        let dark = $logo.data('opposite');
        $logo.data('opposite', $logo.attr('src'));
        $logo.attr('src', dark);
      }

      if ($('.navbar').hasClass('navbar-open')) {
        setTimeout(function () {
          $('.navbar').addClass('navbar-fill');
        }, 200);
      } else {
        $('.navbar').removeClass('navbar-fill');
      }
    });

    function handleFirstTab(e) {
      if (e.keyCode === 9) { // the "I am a keyboard user" key
        document.body.classList.add('user-is-tabbing');
        window.removeEventListener('keydown', handleFirstTab);
      }
    }

    window.addEventListener('keydown', handleFirstTab);

    /**
     * Contact select dropdown
     */
    if ($('select[name="input_1"]').length > 0) {
      $('select[name="input_1"]').customSelect();
    }
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js